var amdi18n={"__root":{"available_cloud_ids":"Available Cloud Identities","no_cloud_identity_available":"No Cloud Identity available yet","no_cloud_identity_available_mobile":"No Cloud Identity available yet. You can create a Cloud Identity on your desktop and transfer it to you mobile.","all_cloud_identities_deleted":"All Cloud Identities have been deleted","add_now":"Add now","cloud_identity":"Cloud Identity","cloud_identity_expired":"Cloud Identity expired","cloud_identity_deactivated":"Cloud Identity deactivated","cloud_identity_insufficient":"Cloud Identity insufficient","add_id":"Add","revoke_ids":"Revoke all"},"__de":{"available_cloud_ids":"Verfügbare Cloud Identitäten","no_cloud_identity_available":"Noch keine Cloud Identität verfügbar","no_cloud_identity_available_mobile":"Noch keine Cloud Identität verfügbar. Sie können sich eine Cloud Identität auf Ihren Desktop erzeugen und auf Ihr Mobiltelefon übertragen.","all_cloud_identities_deleted":"Alle Cloud Identitäten wurden gelöscht","add_now":"Jetzt hinzufügen","cloud_identity":"Cloud Identität","cloud_identity_expired":"Cloud Identität abgelaufen","cloud_identity_deactivated":"Cloud Identität deaktiviert","cloud_identity_insufficient":"Cloud Identität nicht ausreichend","add_id":"Hinzufügen","revoke_ids":"Alle Sperren"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/IdentitiesOverviewState_strings.js
// module id = 169
// module chunks = 2